import React,{useEffect,useState} from 'react';
import { BrowserRouter,Navigate,Route,Routes } from 'react-router-dom';
import {appendLog,loadContacts,loadDeliveries,loadLogs,loadRegistrations,loadSessions,loadWebinars,loadWorkflows,save} from './storage';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import CRM from './pages/CRM';
import Webinars from './pages/Webinars';
import Workflows from './pages/Workflows';
import Attendees from './pages/Attendees';
import FollowUp from './pages/FollowUp';
import Settings from './pages/Settings';
import PublicForm from './pages/PublicForm';
import {applyMeetingStatus} from './meetingStatus';
import './App.css';

function AdminApp() {
  const [contacts,setContacts]=useState(loadContacts);
  const [webinars,setWebinars]=useState(loadWebinars);
  const [sessions,setSessions]=useState(loadSessions);
  const [registrations,setRegistrations]=useState(loadRegistrations);
  const [deliveries,setDeliveries]=useState(loadDeliveries);
  const [workflows,setWorkflows]=useState(loadWorkflows);
  const [logs,setLogs]=useState(loadLogs);
  const [activeContact,setActiveContact]=useState(null);

  useEffect(()=> {
    const refresh=()=> {
      setContacts(loadContacts());
      setWebinars(loadWebinars());
      setSessions(loadSessions());
      setRegistrations(loadRegistrations());
      setDeliveries(loadDeliveries());
      setWorkflows(loadWorkflows());
      setLogs(loadLogs());
    };
    window.addEventListener('awsa-data',refresh);
    return ()=> window.removeEventListener('awsa-data',refresh);
  },[]);
  useEffect(()=> save('awsa_contacts',contacts),[contacts]);
  useEffect(()=> save('awsa_webinars',webinars),[webinars]);
  useEffect(()=> save('awsa_sessions',sessions),[sessions]);
  useEffect(()=> save('awsa_registrations',registrations),[registrations]);
  useEffect(()=> save('awsa_deliveries',deliveries),[deliveries]);
  useEffect(()=> save('awsa_workflows',workflows),[workflows]);
  useEffect(()=> save('awsa_logs',logs),[logs]);

  const updateMeeting=(registrationId,meeting)=>{
    const next=applyMeetingStatus({contacts,registrations},registrationId,meeting);
    if (!next) return;
    setContacts(next.contacts);
    setRegistrations(next.registrations);
    setLogs(list=>appendLog(list,'商談予約ステータス更新',`${registrationId}: ${meeting}（テスト）`));
  };

  const pageProps={updateMeeting,contacts,setContacts,webinars,setWebinars,sessions,setSessions,registrations,setRegistrations,deliveries,setDeliveries,workflows,setWorkflows,logs,setLogs,setActiveContact};
  return <div className="app-shell">
    <Sidebar />
    <main className="main-area">
      <header className="topbar">
        <div><span className="eyebrow">営業オペレーション</span><h1>ウェビナー営業管理</h1></div>
        <div className="topbar-right"><div className="avatar">AW</div></div>
      </header>
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Dashboard {...pageProps} />} />
          <Route path="/webinars" element={<Webinars {...pageProps} />} />
          <Route path="/crm" element={<CRM {...pageProps} activeContact={activeContact} />} />
          <Route path="/attendees" element={<Attendees {...pageProps} />} />
          <Route path="/workflows" element={<Workflows {...pageProps} />} />
          <Route path="/follow-up" element={<FollowUp {...pageProps} />} />
          <Route path="/settings" element={<Settings {...pageProps} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </main>
  </div>;
}

export default function App() {
  return <BrowserRouter>
    <Routes>
      <Route path="/apply/:sessionId" element={<PublicForm />} />
      <Route path="/apply" element={<PublicForm />} />
      <Route path="*" element={<AdminApp />} />
    </Routes>
  </BrowserRouter>;
}
